var map = {
	"./skin1/edit_clothes_highlight@3x.png": "d8bd",
	"./skin2/edit_clothes_highlight@3x.png": "104b",
	"./skin3/edit_clothes_highlight@3x.png": "2802",
	"./skin4/edit_clothes_highlight@3x.png": "3b3d",
	"./skin5/edit_clothes_highlight@3x.png": "7dc9",
	"./skin6/edit_clothes_highlight@3x.png": "b270"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3777";